module.exports = __webpack_public_path__ + "static/img/7.c57c349.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/huawei/7.png
// module id = lAKe
// module chunks = 0